import request from "@/http";
/**
 * 获取我的项目
 * @param {*} data
 * @returns
 */
const getList = (data) => {
    let { begin_idx, limit, id_public_user_info,mid_table_remark_001,mid_table_remark_009, isloading = false, type_middle_app = 80001, type_inner_app = 1001, is_online = 0 } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: begin_idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            pre_db_para_middle_table_name: "public_middle_table_80001",
            id_public_user_info: id_public_user_info,
            mid_table_remark_001_like: mid_table_remark_001,
            mid_table_remark_009: mid_table_remark_009,
            is_online: is_online,
            pre_db_para_order_by_para: " time_insert desc ",
        },
        loading: {
            enabled: isloading
        }
    })
}

/**
 * 获取协作项目
 * @param {*} data
 * @returns
 */
const getOtherList = (data) => {
  let { begin_idx, limit, id_public_user_info,mid_table_remark_001,mid_table_remark_011, isloading = false, type_middle_app = 80001, type_inner_app = 1001, is_online = 0 } = data;
  return request.get({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      pre_db_para_middle_table_name: "public_middle_table_80001",
      mid_table_remark_001_like: mid_table_remark_001,
      mid_table_remark_011_like: mid_table_remark_011,
      is_online: is_online,
        pre_db_para_order_by_para: " time_insert desc ",
    },
    loading: {
      enabled: isloading
    }
  })
}

/**
 * 创建项目
 * @param {*} data
 * @returns
 */
const createProject = (data) => {

    let { id_public_user_info,id_public_middle_table,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_012,mid_table_remark_013,mid_table_remark_014, mid_table_remark_015,isloading, type_middle_app = 80001, type_inner_app = 1001, is_online = 0 } = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
          invoke_method: "public_insert_or_update_middle_table",
          pre_db_para_middle_table_name: "public_middle_table_80001",
          type_middle_app: type_middle_app,
          type_inner_app: type_inner_app,
          id_public_user_info: id_public_user_info,
          pre_db_para_id_public_middle_table: id_public_middle_table,
          mid_table_remark_001: mid_table_remark_001,
          mid_table_remark_002: mid_table_remark_002,
          mid_table_remark_003: mid_table_remark_003,
          mid_table_remark_004: mid_table_remark_004,
          mid_table_remark_005: mid_table_remark_005,
          mid_table_remark_006: mid_table_remark_006,
          mid_table_remark_007: mid_table_remark_007,
          mid_table_remark_008: mid_table_remark_008,
          mid_table_remark_009: mid_table_remark_009,
          mid_table_remark_010: mid_table_remark_010,
          mid_table_remark_011: mid_table_remark_011,
          mid_table_remark_012: mid_table_remark_012,
          mid_table_remark_013: mid_table_remark_013,
          mid_table_remark_014: mid_table_remark_014,
          mid_table_remark_015: mid_table_remark_015,
          is_online: is_online
        },
        loading: {
            enabled: isloading
        }
    })
}
// 查询项目详情
//16
const getDetail = (data) => {

    let { begin_idx, limit, id_public_user_info, id_public_middle_table, isloading = false, type_middle_app = 80001, type_inner_app = 1001, is_online = 0, } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: begin_idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            pre_db_para_middle_table_name: "public_middle_table_80001",
            id_public_user_info: id_public_user_info,
            id_public_middle_table: id_public_middle_table,
            is_online: is_online,
            pre_db_para_order_by_para: " time_insert desc ",
        },
        loading: {
            enabled: isloading
        }
    })
}
const delProject = (data) => {

    let { id_public_middle_table, isloading, type_middle_app = 80001, type_inner_app = 1001, is_online = 111 } = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
          invoke_method: "public_insert_or_update_middle_table",
          pre_db_para_middle_table_name: "public_middle_table_80001",
          type_middle_app: type_middle_app,
          type_inner_app: type_inner_app,
          pre_db_para_id_public_middle_table: id_public_middle_table,
          is_online: is_online
        },
        loading: {
            enabled: isloading
        }
    })
}
/**
 * 获取项目行业分类
 * @param {*} data
 * @returns
 */
const getIndustry = (data) => {

    let {isloading} = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            type_middle_app: 20003,
            type_inner_app: 3003,
            is_online: 0,
            pre_db_para_begin_idx: 0,
            pre_db_para_length_4_list: 10,
            pre_db_para_middle_table_name: "public_middle_table_20003",
            pre_db_para_order_by_para: " time_insert desc ",
        },
        loading: {
            enabled: isloading
        }
    })
}

/**
 * 获取用户数据
 * @param {*} data
 * @returns
 */
const getUserList = (data) => {

  let {isloading,nick_name,userId} = data;
  return request.post({
    url: "duzikai_api_mgr_public_user_info",
    data: {
      invoke_method: "public_page_4m_load_user_list",
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 1000,
      pre_db_para_is_online: 0,
      pre_db_para_order_by_para:'time_register DESC',
      nick_name_like:nick_name,
      id_public_user_info_in:userId,
      pre_cmd_para_t:new Date().getTime()
    },
    loading: {
      enabled: isloading
    }
  })
}

export default {
  getList,
  createProject,
  getDetail,
  delProject,
  getIndustry,
  getUserList,
  getOtherList
}
